import React, { FC } from 'react'
import { CheckboxComponent, Indent, LinkComponent } from 'LibNeo'
import { FieldNames } from 'Src/constants/FieldNames'
import { WrappedFormUtils } from 'antd/lib/form/Form'
import { OutLinks } from 'Constants/OutLinks'
import { getBaseUrl } from '@pp/axios'
import { AgreementForm } from './AgreementForm'

interface ComponentProps {
	form: WrappedFormUtils
	disableAll: boolean
}

export const PaperAgreementFormBlock: FC<ComponentProps> = ({ form, disableAll }) => {
	const checkboxTitle = (
		<span>
			Согласие на обработку персональных данных Клиента получено по{' '}
			<LinkComponent
				title="Шаблону"
				url={`${getBaseUrl(true)}${OutLinks.broker.download_template_agreement}`}
				external
			/>
		</span>
	)

	return (
		<>
			<AgreementForm form={form} disableAll={disableAll} />
			<Indent top={24}>
				<Indent bottom={24}>
					<CheckboxComponent
						form={form}
						fieldName={FieldNames.IS_PAPER_AGREEMENT}
						title={checkboxTitle}
					/>
				</Indent>
			</Indent>
		</>
	)
}
